import { useContext } from 'react';
import { useStaticQuery } from 'gatsby';
import { LanguageContext } from '../providers';
export const useSocialMediaBarData = () => {
  const {
    language
  } = useContext(LanguageContext);
  const {
    directusMenus,
    directusMenusNew
  } = useStaticQuery("4188511289");
  return {
    language,
    networks: directusMenus,
    networksNew: directusMenusNew
  };
};